import { Box, Text } from "@chakra-ui/react";
import NewDeployemnt from "../../Assistants/NewDeployemnt";

const DeployTab = ({ assistantId, assistantType }) => {
  if (!assistantId) {
    return (
      <Box py={8} textAlign="center">
        <Text color="gray.400" fontSize="sm">
          Save the assistant first to configure deployments.
        </Text>
      </Box>
    );
  }

  // NewDeployemnt expects assistantData object with id
  const assistantData = { id: assistantId, assistant_type: assistantType };

  return (
    <Box>
      <Text fontSize="xs" color="gray.500" mb={4}>
        Push your {assistantType === "phone" ? "voice assistant" : "chatbot"} live to your customers.
      </Text>
      <NewDeployemnt assistantData={assistantData} />
    </Box>
  );
};

export default DeployTab;
